// Attaches bootstrap validation classes ('has-error', 'has-success') to
// the element if according to the current validation status.

// Inspired by: https://github.com/paulyoder/angular-bootstrap-show-errors
const classNames = {
  error: 'has-error',
  success: 'has-success',
};

const getInputName = element =>
  element[0].querySelector('.form-control[name]').getAttribute('name');

function bsHasSuccess($interpolate) {
  'ngInject';
  return {
    restrict: 'A',
    require: '^form',

    link(scope, element, attrs, formCtrl) {
      let inputName = $interpolate(getInputName(element))(scope);
      let input = formCtrl[inputName] || formCtrl[scope.name];

      return scope.$watch(() => input.$valid, function(toggle) {
        if (toggle != null) {
          return element.toggleClass(classNames.success, toggle);
        }
      });
    },
  };
}

function bsHasError($interpolate) {
  'ngInject';
  return {
    restrict: 'A',
    require: '^form',

    link(scope, element, attrs, formCtrl) {
      let blurredOnce = false;
      let inputName = $interpolate(getInputName(element))(scope);

      let input = formCtrl[inputName] || formCtrl[scope.name];
      // Throughout the app we don't show error messages in forms while
      // the user is focused on the input unless they've blurred. For
      // asynchronous validation, this might not always make sense, so
      // by using the `show-while-focusing` attribute you can opt-out
      // of this functionality
      if (attrs.showWhileFocusing) {
        blurredOnce = true;
      } else {
        var blurListener = scope.$watch(() => input.$focusing, function(
          newValue,
          oldValue
        ) {
          blurredOnce = !newValue && oldValue;
          if (blurredOnce) {
            return blurListener();
          }
        });
      }

      return scope.$watch(
        () =>
          input.$invalid &&
          (formCtrl.$submitted ||
            formCtrl.$$parentForm.$submitted ||
            (input.$dirty && blurredOnce)),
        function(toggle) {
          if (toggle != null) {
            return element.toggleClass(classNames.error, toggle);
          }
        }
      );
    },
  };
}

export default angular
  .module('app.directives.bs-form-validation', [])
  .directive('bsHasError', bsHasError)
  .directive('bsHasSuccess', bsHasSuccess);
